// extracted by mini-css-extract-plugin
export default {"root":"style_root__IvcVc","loaderContainer":"style_loaderContainer__fav8q","loaderContainer__loaded":"style_loaderContainer__loaded__-hJwA","image":"style_image__z-lDV"};